{
  "pages": {
    "cashbookTitle": "Sổ quỹ",
    "permissionDenied": "Bạn không có quyền xem sổ quỹ."
  },
  "fields": {
    "date": "Ngày",
    "type": "Loại",
    "code": "Mã",
    "description": "Mô tả",
    "amount": "Số tiền",
    "runningBalance": "Số dư ròng",
    "clinic": "Phòng khám",
    "paymentMethod": "Hình thức thanh toán",
    "createdAt": "Ngày tạo",
    "category": "Danh mục",
    "notes": "Ghi chú",
    "recordedBy": "Người tạo phiếu",
    "confirmedBy": "Người xác nhận",
    "confirmedAt": "Thời điểm xác nhận",
    "slipSource": "Nguồn phiếu",
    "patient": "Bệnh nhân",
    "treatmentPlan": "Kế hoạch điều trị"
  },
  "slipSources": {
    "payment": "Thanh toán",
    "manual": "Thu tay",
    "walletTopup": "Nạp ví",
    "expense": "Phiếu chi"
  },
  "summary": {
    "totalIncome": "Tổng thu",
    "totalExpense": "Tổng chi",
    "netBalance": "Số dư ròng"
  },
  "types": {
    "all": "Tất cả",
    "income": "Thu",
    "expense": "Chi"
  },
  "groupBy": {
    "menuTitle": "Nhóm theo",
    "none": "Không nhóm",
    "category": "Danh mục",
    "paymentMethod": "Hình thức thanh toán"
  },
  "search": {
    "placeholder": "Tìm theo mã, mô tả..."
  },
  "filters": {
    "trigger": "Bộ lọc",
    "title": "Lọc sổ quỹ",
    "clearAll": "Xóa tất cả",
    "apply": "Áp dụng",
    "dateRange": "Khoảng thời gian",
    "dateRangePlaceholder": "Chọn khoảng ngày",
    "selectCategory": "Chọn danh mục",
    "allCategories": "Tất cả danh mục",
    "selectMethod": "Chọn phương thức thanh toán",
    "allMethods": "Tất cả phương thức",
    "selectSlipSource": "Chọn nguồn phiếu",
    "allSlipSources": "Tất cả nguồn",
    "selectRecordedBy": "Chọn người tạo phiếu",
    "allRecordedBy": "Tất cả người tạo",
    "selectClinic": "Chọn phòng khám",
    "allClinics": "Tất cả phòng khám"
  },
  "table": {
    "empty": "Không có giao dịch nào trong khoảng thời gian này."
  },
  "actions": {
    "export": "Xuất CSV"
  },
  "toasts": {
    "loadFailed": "Không tải được sổ quỹ",
    "loadError": "Lỗi khi tải sổ quỹ. Vui lòng thử lại.",
    "exported": "Đã xuất sổ quỹ",
    "exportFailed": "Không xuất được sổ quỹ"
  },
  "pagination": {
    "rowsPerPage": "Số dòng mỗi trang:",
    "displayedRows": "{{from}}–{{to}} / {{count}}",
    "moreThan": "hơn {{to}}"
  }
}
